import { config } from 'config';

import s from './Errors.module.css';

export function GenericError() {
  return (
    <div className={s.root}>
      <h1 className={s.title}>Sorry, we ran into a problem.</h1>
      <p className={s.text}>
        Are you a professional considering GlossGenius for your business?{' '}
        <a className={s.link} href={config.rootUrl}>
          Learn more and sign up here.
        </a>
      </p>
    </div>
  );
}
